import React from "react";
import { Redirect } from "react-router-dom";
import Demo from "./Demo";
import CityCouncil from "./data/cityCouncil.json";
import Dem2020 from "./data/dem2020.json";
import Rep2020 from "./data/rep2020.json";
import MetaVote from "./data/metaVote.json";
import BidenVP from "./data/bidenvp.json";

export default function DemoPage({ match, history }) {
  const params = match.params;
  const raceName = params.race ? params.race.toLowerCase() : "";
  const data = (function(name) {
    switch (name) {
      case "bidenvp":
        return BidenVP;
      case "dem2020":
        return Dem2020;
      case "rep2020":
        return Rep2020;
      case "metavote":
        return MetaVote;
      case "citycouncil":
        return CityCouncil;
      default:
        return null;
    }
  })(raceName);

  if (data)
    return (
      <Demo
        path={`/demo/${raceName}`}
        race={data.race}
        candidates={data.candidates}
        history={history}
      />
    );
  return <Redirect to="/" />;
}
